import { Grid, Box } from '@mui/material';
import { useField, useFormikContext } from 'formik';
import React from 'react';
import { SparkTextField } from 'sharedComponents/SparkForm';
import { StepperBox } from 'sharedComponents/SparkForm/StepperBox';
import type { DropdownOption } from 'types/common/DropdownOption';
import { ObjectivesFormValues } from './ObjectivesForm';

type ObjectiveFormContentProps = {
  keyObjectivesIdByNameMap: Record<string, string> | undefined;
  objectivesOptions: DropdownOption[];
};

function ObjectiveFormContent({
  keyObjectivesIdByNameMap,
  objectivesOptions,
}: ObjectiveFormContentProps) {
  const [field, _, helpers] = useField<string[]>('objectiveIDs');
  const { setValues } = useFormikContext<ObjectivesFormValues>();
  const handleItemClick = (itemID: string) => {
    if (field.value?.includes(itemID)) {
      helpers.setValue(field.value.filter((value) => value !== itemID));
      return;
    }
    if (field.value.length < 3) {
      helpers.setValue([...field.value, itemID]);
    }
  };

  React.useEffect(() => {
    if (!field.value?.includes('10')) {
      setValues((prev) => ({ ...prev, otherObjective: '' }));
    }
  }, [field.value, setValues]);
  return (
    <>
      <Grid
        item
        container
        xs={12}
        columnSpacing={2}
        rowGap={2}
        paddingBottom={3}
      >
        {objectivesOptions.map((option) => (
          <StepperBox
            key={option.value}
            handleItemClick={handleItemClick}
            option={option}
            isSelected={field.value?.includes(option.value as string)}
          />
        ))}
      </Grid>
      {!!keyObjectivesIdByNameMap &&
        field.value?.includes(keyObjectivesIdByNameMap?.['Other']) && (
          <Box marginTop={2} width='100%'>
            <SparkTextField
              placeholder='e.g. Sustainability and Social Impact'
              name='otherObjective'
              sx={{ width: '100%' }}
              label='Other'
              size={12}
              hideHelperText={true}
            />
          </Box>
        )}
    </>
  );
}

export default ObjectiveFormContent;
